/**
 * 이미지 URL을 안전하게 변환하는 헬퍼 함수
 * 1) null, undefined, 빈 문자열이면 fallback 반환
 * 2) http:// 또는 https://로 시작하면 (Cloudflare R2 등) 그대로 반환
 * 3) 상대 경로(public/...)이면 REACT_APP_API_URL과 조합하여 반환
 */
export const getImageUrl = (
  path?: string | null,
  fallback: string = '',
): string => {
  if (!path) return fallback;
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const baseUrl = process.env.REACT_APP_API_URL || '';
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${baseUrl}/${cleanPath}`;
};
